import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import { WidgetViewExtension } from '@blocksuite/std';
import { literal, unsafeStatic } from 'lit/static-html.js';

import {
  AFFINE_EDGELESS_REMOTE_SELECTION_WIDGET,
  EdgelessRemoteSelectionWidget,
} from './edgeless';

export const edgelessRemoteSelectionWidget = WidgetViewExtension(
  'affine:page',
  AFFINE_EDGELESS_REMOTE_SELECTION_WIDGET,
  literal`${unsafeStatic(AFFINE_EDGELESS_REMOTE_SELECTION_WIDGET)}`
);

export function edgelessPresenceEffects() {
  if (!customElements.get(AFFINE_EDGELESS_REMOTE_SELECTION_WIDGET))
    customElements.define(
      AFFINE_EDGELESS_REMOTE_SELECTION_WIDGET,
      EdgelessRemoteSelectionWidget
    );
}
export class EdgelessPresenceViewExtension extends ViewExtensionProvider {
  override name = 'edgeless-presence';
  override effect() {
    super.effect();
    edgelessPresenceEffects();
  }
  override setup(context: ViewExtensionContext) {
    super.setup(context);
    if (context.scope === 'edgeless')
      context.register(edgelessRemoteSelectionWidget);
  }
}
